import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "design-system/atoms/Dialog"
import { Trash } from "lucide-react"
import { useDeletePastFakeConversationsMutation } from "modules/conversations/hooks/useDeletePastFakeConversationsMutation"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { ConversationsResponseDataSchema, CustomerResponseDataSchema } from "schema"
import { toast } from "sonner"
import z from "zod"

type Props = {
  customer: z.infer<typeof CustomerResponseDataSchema>
  conversations: z.infer<typeof ConversationsResponseDataSchema>
}

export function DeletePastFakeConversationsDialog({ customer, conversations }: Props) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const { mutateAsync: deletePastFakeConversations, isPending: isDeletingPastFakeConversations } =
    useDeletePastFakeConversationsMutation({
      params: { customerId: customer.id },
    })

  if (!customer.isFake) return null
  if (conversations.length <= 1) return null

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="destructive"
          disabled={isDeletingPastFakeConversations}
          className="w-fit"
          size={"sm"}
        >
          <Trash className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("conversations.chat.noConversations.deleteOldTestingConversations")}
          </DialogTitle>
          <DialogDescription>
            {t("conversations.chat.noConversations.deleteOldTesintConversationsDecription")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={isDeletingPastFakeConversations}>
              <span>{t("shared.cancel")}</span>
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={async () => {
              await deletePastFakeConversations()
              setOpen(false)
              toast.success(t("conversations.chat.noConversations.pastConversationsDeleted"))
            }}
            disabled={isDeletingPastFakeConversations}
          >
            <span>{t("shared.confirm")}</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
